import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["level"],
    _excluded2 = ["grey", "italic", "bold", "semibold"],
    _excluded3 = ["grey", "italic", "bold", "semibold"],
    _excluded4 = ["grey", "italic", "bold", "semibold"],
    _excluded5 = ["grey", "italic", "bold", "semibold"];
import React, { forwardRef } from 'react';
import Text from './text';
import { map } from './utils';
export var Heading = /*#__PURE__*/forwardRef(function Heading(_ref, ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 1 : _ref$level,
      props = _objectWithoutProperties(_ref, _excluded);

  var h = level === 'display' ? 1 : level;
  var as = "h".concat(h);
  return /*#__PURE__*/React.createElement(Text, _extends({
    type: ['HEADING', "HEADING".concat(level === 'display' ? '_DISPLAY' : level)],
    as: as
  }, props, {
    ref: ref
  }));
});
export var Body = /*#__PURE__*/forwardRef(function Body(_ref2, ref) {
  var grey = _ref2.grey,
      italic = _ref2.italic,
      bold = _ref2.bold,
      semibold = _ref2.semibold,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(Text, _extends({
    type: map({
      BODY: true,
      ITALIC: italic,
      BOLD: bold,
      SEMIBOLD: semibold,
      GREY: grey
    }),
    as: "p"
  }, props, {
    ref: ref
  }));
});
export var Tiny = /*#__PURE__*/forwardRef(function Tiny(_ref3, ref) {
  var grey = _ref3.grey,
      italic = _ref3.italic,
      bold = _ref3.bold,
      semibold = _ref3.semibold,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(Text, _extends({
    type: map({
      TINY: true,
      ITALIC: italic,
      BOLD: bold,
      SEMIBOLD: semibold,
      GREY: grey
    }),
    as: "p"
  }, props, {
    ref: ref
  }));
});
export var Small = /*#__PURE__*/forwardRef(function Small(_ref4, ref) {
  var grey = _ref4.grey,
      italic = _ref4.italic,
      bold = _ref4.bold,
      semibold = _ref4.semibold,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(Text, _extends({
    type: map({
      SMALL: true,
      ITALIC: italic,
      BOLD: bold,
      SEMIBOLD: semibold,
      GREY: grey
    }),
    as: "p"
  }, props, {
    ref: ref
  }));
});
export var Large = /*#__PURE__*/forwardRef(function Large(_ref5, ref) {
  var grey = _ref5.grey,
      italic = _ref5.italic,
      bold = _ref5.bold,
      semibold = _ref5.semibold,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(Text, _extends({
    type: map({
      LARGE: true,
      ITALIC: italic,
      BOLD: bold,
      SEMIBOLD: semibold,
      GREY: grey
    }),
    as: "p"
  }, props, {
    ref: ref
  }));
});
export var Label = /*#__PURE__*/forwardRef(function Label(props, ref) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    type: ['LABEL'],
    as: 'label'
  }, props, {
    ref: ref
  }));
});
export var Bold = /*#__PURE__*/forwardRef(function Bold(props, ref) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    type: ['BOLD'],
    as: 'b'
  }, props, {
    ref: ref
  }));
});
export var Semibold = /*#__PURE__*/forwardRef(function Semibold(props, ref) {
  return /*#__PURE__*/React.createElement(Text, _extends({
    type: ['SEMIBOLD'],
    as: 'b'
  }, props, {
    ref: ref
  }));
});